<template>
  <van-popup v-model="visible" position="bottom" round :style="{ width: '100%', height: '82%', background: '#f7f5f0', overflow: 'hidden' }" @closed="handleClosed">
    <div class="goodsPopup">
      <!-- 顶部拖拽条 -->
      <div class="gp_handle">
        <div class="gp_handle_bar"></div>
      </div>

      <!-- 加载中 -->
      <div class="gp_loading" v-if="loading">
        <div class="gp_spinner"></div>
        <div class="gp_loading_text">加载中...</div>
      </div>

      <template v-else>
        <!-- 内容滚动区 -->
        <div class="gp_scroll">
          <!-- 轮播图（原生实现） -->
          <div class="gp_swiper_wrap">
            <div class="gp_swiper" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
              <div class="gp_swiper_track" :style="trackStyle">
                <img v-for="(img, index) in product.sliderImageArr" :key="index" :src="img" class="gp_swiper_img" @click="previewBanner(index)" />
              </div>
              <!-- 指示点 -->
              <div class="gp_dots" v-if="(product.sliderImageArr || []).length > 1">
                <span v-for="(img, index) in product.sliderImageArr" :key="index" class="gp_dot" :class="{ active: currentSlide === index }"></span>
              </div>
            </div>
          </div>

          <!-- 商品信息 -->
          <div class="gp_card gp_goods_info">
            <div class="gp_price_row">
              <div class="gp_price">
                <span class="gp_price_symbol">¥</span>{{ attr.productSelect.price || product.price }}
              </div>
              <div class="gp_stock">库存 {{ attr.productSelect.stock || product.stock }}</div>
            </div>
            <div class="gp_title">{{ product.storeName }}</div>
            <div class="gp_dec" v-if="product.storeInfo">{{ product.storeInfo }}</div>
          </div>

          <!-- 店铺信息 -->
          <div class="gp_card gp_shop" v-if="shopInfo && shopInfo.name">
            <img class="gp_avatar" :src="shopInfo.image || '/images/logo.png'" />
            <div class="gp_shop_info">
              <div class="gp_shop_name">{{ shopInfo.name }}</div>
              <div class="gp_shop_dec">{{ shopInfo.address }}</div>
            </div>
            <div class="gp_loc" v-if="shopInfo.distance">
              <span>距您{{ shopInfo.distance }}km</span>
            </div>
          </div>

          <!-- 运费 -->
          <div class="gp_card gp_row_card">
            <div class="gp_label">运费</div>
            <div class="gp_value">{{ tempName }}</div>
          </div>

          <!-- 评价 -->
          <div class="gp_card" v-if="replyCount > 0">
            <div class="gp_reply_head">
              <div class="gp_label_b">买家评价（{{ replyCount }}）</div>
              <div class="gp_reply_rate">好评率<span class="gp_rate_num">{{ replyChance }}%</span></div>
            </div>
            <div class="gp_reply_item" v-if="reply">
              <div class="gp_reply_user">
                <img class="gp_avatar sm" :src="reply.avatarUrl || '/images/default-avatar.png'" />
                <span>{{ reply.nickName }}</span>
              </div>
              <div class="gp_reply_text">{{ reply.comment }}</div>
              <div class="gp_pics" v-if="reply.picturesArr && reply.picturesArr.length">
                <img v-for="(img, i) in reply.picturesArr" :key="i" :src="img" class="gp_pic" @click="previewReply(img)" />
              </div>
            </div>
          </div>

          <!-- 商品简介：图片 或 富文本 -->
          <div class="gp_card">
            <template v-if="isDescImg">
              <img v-for="(img, i) in descImages" :key="i" :src="img" class="gp_rich_img" />
            </template>
            <div v-else class="gp_rich" v-html="product.description"></div>
          </div>

          <div style="height: 40px;"></div>
        </div>

        <!-- 底部操作栏（只留立即购买） -->
        <div class="gp_footer">
          <div class="gp_btn buy" @click="tapBuy">立即购买</div>
        </div>
      </template>

      <!-- ===== 规格选择二级弹层 ===== -->
      <van-popup v-model="specShow" position="bottom" round :style="{ background: '#fff' }">
        <div class="gp_spec_panel">
          <div class="gp_spec_top">
            <img class="gp_spec_img" v-if="attr.productSelect.image" :src="attr.productSelect.image" />
            <div class="gp_spec_main">
              <div class="gp_spec_price">
                <span class="gp_price_symbol">¥</span>{{ attr.productSelect.price || product.price }}
              </div>
              <div class="gp_spec_stock">库存 {{ attr.productSelect.stock || product.stock }}</div>
            </div>
            <div class="gp_spec_close" @click="specShow = false">×</div>
          </div>

          <div class="gp_spec_list" v-if="attr.productAttr.length > 0">
            <div class="gp_attr" v-for="(items, idx) in attr.productAttr" :key="idx">
              <div class="gp_attr_title">{{ items.attrName }}</div>
              <div class="gp_attr_btns">
                <span v-for="(v, i) in attrOptions(items)" :key="i" class="gp_attr_btn" :class="{ on: items.index === i }" @click="selectAttr(idx, i)">{{ optionText(v) }}</span>
              </div>
            </div>
          </div>

          <!-- 数量选择（原生） -->
          <div class="gp_num_row">
            <div class="gp_num_title">数量</div>
            <div class="gp_num_box">
              <span class="gp_num_btn" @click="changeNum(-1)">-</span>
              <span class="gp_num_input">{{ num }}</span>
              <span class="gp_num_btn" @click="changeNum(1)">+</span>
            </div>
          </div>

          <div class="gp_spec_foot">
            <div v-if="attr.productAttr.length > 0 && !attrValue" class="gp_btn buy disabled">请选择规格</div>
            <div v-else-if="!attr.productSelect.stock" class="gp_btn buy disabled">库存不足</div>
            <div v-else class="gp_btn buy" @click="doAddCart">立即购买</div>
          </div>
        </div>
      </van-popup>
    </div>
  </van-popup>
</template>

<script>
import { Toast, ImagePreview } from "vant";
import wx from "weixin-js-sdk";

export default {
  name: "GoodsPopup",
  data() {
    return {
      visible: false,
      loading: false,
      productId: "",
      merId: "",
      // ✅ 初始化就带上 sliderImageArr，避免模板渲染 undefined.length 报错
      product: { sliderImageArr: [] },
      attr: { productAttr: [], productSelect: {} },
      productValue: {},
      attrValue: "",
      shopInfo: {},
      tempName: "包邮",
      reply: null,
      replyChance: 0,
      replyCount: 0,
      isDescImg: false,
      descImages: [],
      specShow: false,
      num: 1,
      // 轮播相关
      currentSlide: 0,
      touchStartX: 0,
      touchMoveX: 0,
      isTouching: false
    };
  },
  computed: {
    trackStyle() {
      const count = (this.product.sliderImageArr || []).length;
      if (!count) return {};
      const offset = -this.currentSlide * 100;
      const dragPercent = this.isTouching ? ((this.touchMoveX - this.touchStartX) / window.innerWidth) * 100 / count : 0;
      return {
        width: count * 100 + "%",
        transform: `translateX(calc(${offset}% + ${dragPercent}%))`,
        transition: this.isTouching ? "none" : "transform 0.3s ease"
      };
    }
  },
  methods: {
    /* ============ 对外 API ============ */
    open(productId) {
      if (!productId) return;
      this.reset();
      this.productId = productId;
      this.visible = true;
      this.loading = true;
      this.requestDetail();
    },

    reset() {
      // ✅ 同步初始化 sliderImageArr，防止关闭再开时渲染报错
      this.product = { sliderImageArr: [] };
      this.attr = { productAttr: [], productSelect: {} };
      this.productValue = {};
      this.attrValue = "";
      this.shopInfo = {};
      this.reply = null;
      this.replyCount = 0;
      this.replyChance = 0;
      this.tempName = "包邮";
      this.isDescImg = false;
      this.descImages = [];
      this.num = 1;
      this.specShow = false;
      this.currentSlide = 0;
    },

    handleClosed() {
      this.reset();
      this.productId = "";
      this.loading = false;
    },

    /* ============ 请求详情 ============ */
    requestDetail() {
      const toast = Toast.loading({ duration: 0, forbidClick: true, message: "加载中..." });
      this.$http
          .get(`/api/product/detail/${this.productId}`)
          .then(res => {
            // 兼容拦截器是否解包：完整 body 或直接 data
            const body = res.data || {};
            const data = body.data || body;

            const storeInfo = data.storeInfo || {};
            let sliderImages = storeInfo.sliderImageArr || [];
            if (!sliderImages.length && storeInfo.sliderImage) {
              sliderImages = String(storeInfo.sliderImage).split(",");
            }

            const description = storeInfo.description || "";
            const isDescImg = /^https?:\/\//.test(String(description).trim());
            let descImages = [];
            if (isDescImg) {
              descImages = String(description)
                  .split(/[,，\n]/)
                  .filter(item => item.trim() !== "");
            }

            this.product = { ...storeInfo, sliderImageArr: sliderImages };
            this.merId = data.merId || storeInfo.merId || "";
            this.attr = {
              productAttr: data.productAttr || [],
              productSelect: {
                price: storeInfo.price,
                stock: storeInfo.stock,
                image: storeInfo.image
              }
            };
            this.productValue = data.productValue || {};
            this.shopInfo = data.systemStore || {};
            this.tempName = data.tempName || "包邮";
            this.reply = data.reply;
            this.replyChance = data.replyChance || 0;
            this.replyCount = data.replyCount || 0;
            this.isDescImg = isDescImg;
            this.descImages = descImages;

            this.defaultSelect();
            this.loading = false;
          })
          .catch(err => {
            console.error("商品详情加载失败:", err);
            this.$toast.fail((err && err.msg) || "加载失败");
            this.loading = false;
            this.visible = false;
          })
          .finally(() => toast.clear());
    },

    /* ============ 规格工具 ============ */
    attrOptions(item) {
      return item.attrValueArr && item.attrValueArr.length ? item.attrValueArr : item.attrValue || [];
    },

    optionText(v) {
      return typeof v === "string" ? v : v.attr;
    },

    // ✅ 多规格默认不选中，强制用户先选规格
    defaultSelect() {
      const { productAttr } = this.attr;
      if (!productAttr || productAttr.length === 0) {
        // 单规格：直接锁定唯一 sku
        this.attrValue = this.product.unique || "";
        return;
      }
      // 多规格：index 置 -1（不选中任何项）
      productAttr.forEach(attr => this.$set(attr, "index", -1));
      this.attrValue = "";
    },

    selectAttr(idx, index) {
      this.attr.productAttr[idx].index = index;
      this.applySelection();
    },

    applySelection() {
      const productAttr = this.attr.productAttr;
      const selectedValues = productAttr.map(attr => {
        const idx = attr.index;
        if (idx === undefined || idx === null || idx < 0) return ""; // 未选中
        const vals = this.attrOptions(attr);
        const v = vals[idx];
        return typeof v === "string" ? v : (v && v.attr) || "";
      });
      // 过滤掉未选中的维度，用剩余维度拼 sku key
      const skuKey = selectedValues.filter(Boolean).join(",");
      const selectedSku = this.productValue[skuKey];

      if (selectedSku) {
        this.$set(this.attr, "productSelect", { ...selectedSku, cart_num: 1 });
        this.attrValue = selectedSku.unique;
        this.num = 1;
      } else {
        // 未选完或组合不存在：保持默认展示，不锁定 sku
        this.$set(this.attr, "productSelect", {
          ...this.attr.productSelect,
          stock: this.product.stock,
          unique: ""
        });
        this.attrValue = "";
      }
    },

    /* ============ 数量选择 ============ */
    changeNum(diff) {
      const max = this.attr.productSelect.stock || 999;
      const next = this.num + diff;
      if (next < 1 || next > max) return;
      this.num = next;
    },

    /* ============ 立即购买 ============ */
    tapBuy() {
      if (this.attr.productAttr.length > 0 && !this.attrValue) {
        this.specShow = true;
        return;
      }
      this.doAddCart();
    },

    doAddCart() {
      const { attrValue, num, product, merId } = this;
      if (this.attr.productAttr.length > 0 && !attrValue) {
        this.specShow = true;
        return;
      }

      const toast = Toast.loading({ duration: 0, forbidClick: true, message: "跳转中..." });
      this.$http
          .post("/cart/add", {
            productId: product.id,
            cartNum: num,
            uniqueId: attrValue || "",
            new: 1
          })
          .then(res => {
            const body = res.data || {};
            const payload = body.data || body;
            this.visible = false;
            this.specShow = false;
            wx.miniProgram.navigateTo({
              url: `/pages/enterOrder/enterOrder?cartId=${payload.cartId}&merId=${merId}`
            });
          })
          .catch(err => {
            this.$toast.fail((err && err.msg) || "操作失败");
          })
          .finally(() => toast.clear());
    },

    /* ============ 原生轮播手势 ============ */
    onTouchStart(e) {
      if (!this.product.sliderImageArr || this.product.sliderImageArr.length <= 1) return;
      this.isTouching = true;
      this.touchStartX = e.touches[0].clientX;
      this.touchMoveX = e.touches[0].clientX;
    },

    onTouchMove(e) {
      if (!this.isTouching) return;
      this.touchMoveX = e.touches[0].clientX;
    },

    onTouchEnd() {
      if (!this.isTouching) return;
      this.isTouching = false;
      const diff = this.touchMoveX - this.touchStartX;
      const count = this.product.sliderImageArr.length;
      const threshold = 50;
      if (diff < -threshold && this.currentSlide < count - 1) {
        this.currentSlide++;
      } else if (diff > threshold && this.currentSlide > 0) {
        this.currentSlide--;
      }
    },

    /* ============ 图片预览 ============ */
    previewBanner(index) {
      ImagePreview({ images: this.product.sliderImageArr, startPosition: index });
    },

    previewReply(img) {
      ImagePreview({ images: this.reply.picturesArr, startPosition: this.reply.picturesArr.indexOf(img) });
    }
  }
};
</script>

<style lang="less" scoped>
@primary: #9d2933;
@text-primary: #222;
@text-secondary: #666;
@border-color: #eaeaea;
@bg-page: #f7f5f0;
@bg-card: #fff;

.goodsPopup {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  .gp_handle {
    display: flex;
    justify-content: center;
    padding: 10px 0 6px;
    background: @bg-card;
    flex-shrink: 0;

    .gp_handle_bar {
      width: 36px;
      height: 4px;
      border-radius: 999px;
      background: #ddd;
    }
  }

  .gp_loading {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;

    .gp_spinner {
      width: 28px;
      height: 28px;
      border: 2px solid #eee;
      border-top-color: @primary;
      border-radius: 50%;
      animation: gp_spin 0.8s linear infinite;
    }

    .gp_loading_text {
      font-size: 13px;
      color: #999;
    }
  }
}

@keyframes gp_spin {
  to { transform: rotate(360deg); }
}

.goodsPopup {
  .gp_scroll {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .gp_swiper_wrap {
    background: @bg-card;

    .gp_swiper {
      position: relative;
      width: 100%;
      height: 240px;
      overflow: hidden;

      .gp_swiper_track {
        display: flex;
        height: 100%;
        will-change: transform;
      }

      .gp_swiper_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        flex-shrink: 0;
        -webkit-user-drag: none;
        user-select: none;
      }

      .gp_dots {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        gap: 6px;

        .gp_dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          transition: all 0.3s;

          &.active {
            background: @primary;
            width: 16px;
            border-radius: 3px;
          }
        }
      }
    }
  }

  .gp_card {
    background: @bg-card;
    margin: 8px 12px 0;
    border-radius: 8px;
    padding: 12px;
  }

  .gp_goods_info {
    .gp_price_row {
      display: flex;
      align-items: baseline;
      gap: 12px;
      margin-bottom: 8px;

      .gp_price {
        color: @primary;
        font-size: 20px;
        font-weight: 600;

        .gp_price_symbol {
          font-size: 14px;
        }
      }

      .gp_stock {
        font-size: 11px;
        color: @text-secondary;
      }
    }

    .gp_title {
      font-size: 16px;
      font-weight: 600;
      color: @text-primary;
      line-height: 1.4;
      margin-bottom: 4px;
    }

    .gp_dec {
      font-size: 11px;
      color: @text-secondary;
      line-height: 1.5;
    }
  }

  .gp_shop {
    display: flex;
    align-items: center;
    gap: 8px;

    .gp_avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
      flex-shrink: 0;
      background: @bg-page;

      &.sm {
        width: 30px;
        height: 30px;
      }
    }

    .gp_shop_info {
      flex: 1;
      overflow: hidden;

      .gp_shop_name {
        font-size: 14px;
        font-weight: 500;
        color: @text-primary;
      }

      .gp_shop_dec {
        font-size: 11px;
        color: @text-secondary;
        margin-top: 2px;
      }
    }

    .gp_loc {
      flex-shrink: 0;

      span {
        font-size: 11px;
        color: @text-secondary;
      }
    }
  }

  .gp_row_card {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .gp_label {
      font-size: 14px;
      color: @text-secondary;
    }

    .gp_value {
      font-size: 14px;
      color: @text-primary;
    }
  }

  .gp_reply_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .gp_label_b {
      font-size: 14px;
      font-weight: 600;
      color: @text-primary;
    }

    .gp_reply_rate {
      font-size: 11px;
      color: @text-primary;

      .gp_rate_num {
        color: @primary;
        margin-left: 2px;
      }
    }
  }

  .gp_reply_user {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 500;
    color: @text-primary;
  }

  .gp_reply_text {
    font-size: 12px;
    color: @text-primary;
    line-height: 1.6;
    margin-bottom: 8px;
  }

  .gp_pics {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    .gp_pic {
      width: 31%;
      aspect-ratio: 1/1;
      object-fit: cover;
      border-radius: 4px;
      background: @bg-page;
    }
  }

  .gp_rich_img {
    width: 100%;
    display: block;
    border-radius: 4px;
    margin-top: 8px;

    &:first-child {
      margin-top: 0;
    }
  }

  .gp_rich {
    width: 100%;
    font-size: 13px;
    line-height: 1.6;

    /deep/ img {
      max-width: 100% !important;
    }
  }

  /* 底部操作栏：只放一个全宽立即购买 */
  .gp_footer {
    flex-shrink: 0;
    padding: 12px;
    padding-bottom: calc(12px + constant(safe-area-inset-bottom));
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    background: @bg-card;
    box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.05);
  }
}

/* 通用按钮（底部栏 + 规格面板共用） */
.gp_btn {
  display: block;
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  border-radius: 12px;
  background: @primary;
  box-sizing: border-box;
  cursor: pointer;

  &.disabled {
    background: #ccc;
    pointer-events: none;
  }
}

/* ===== 规格选择二级弹层 ===== */
.gp_spec_panel {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .gp_spec_top {
    position: relative;
    padding: 50px 12px 12px;
    display: flex;
    align-items: flex-end;
    gap: 8px;
    border-bottom: 1px solid @border-color;
    flex-shrink: 0;

    .gp_spec_img {
      width: 90px;
      height: 90px;
      border-radius: 6px;
      object-fit: cover;
      margin-top: -30px;
      border: 1px solid @border-color;
      background: #fff;
      flex-shrink: 0;
    }

    .gp_spec_main {
      flex: 1;
      padding-bottom: 5px;

      .gp_spec_price {
        color: @primary;
        font-size: 18px;
        font-weight: 600;

        .gp_price_symbol {
          font-size: 12px;
        }
      }

      .gp_spec_stock {
        color: @text-secondary;
        font-size: 12px;
        margin-top: 4px;
      }
    }

    .gp_spec_close {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 22px;
      color: #999;
      cursor: pointer;
      line-height: 1;
    }
  }

  .gp_spec_list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 12px;

    .gp_attr {
      margin-bottom: 15px;

      .gp_attr_title {
        font-size: 14px;
        color: @text-primary;
        margin-bottom: 8px;
        text-align: left;
      }

      .gp_attr_btns {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: flex-start;

        .gp_attr_btn {
          padding: 0 12px;
          height: 30px;
          line-height: 28px;
          min-width: 50px;
          text-align: center;
          border-radius: 999px;
          border: 1px solid @border-color;
          background: @bg-page;
          color: @text-primary;
          font-size: 12px;
          cursor: pointer;
          transition: all 0.2s;

          &.on {
            color: @primary;
            border-color: @primary;
            background: rgba(157, 41, 51, 0.05);
          }
        }
      }
    }
  }

  .gp_num_row {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border-top: 1px solid @border-color;

    .gp_num_title {
      color: @text-primary;
      font-size: 14px;
    }

    .gp_num_box {
      display: flex;
      align-items: center;

      .gp_num_btn {
        width: 30px;
        height: 28px;
        line-height: 26px;
        text-align: center;
        border: 1px solid @border-color;
        background: #fff;
        border-radius: 4px;
        font-size: 16px;
        color: @text-primary;
        cursor: pointer;
        user-select: none;
      }

      .gp_num_input {
        width: 40px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-top: 1px solid @border-color;
        border-bottom: 1px solid @border-color;
        background: #fff;
        font-size: 13px;
        color: @text-primary;
      }
    }
  }

  .gp_spec_foot {
    flex-shrink: 0;
    padding: 8px 12px;
    padding-bottom: calc(12px + constant(safe-area-inset-bottom));
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
  }
}
</style>
